import React, { useEffect } from 'react';
import { sortByHighestSeverity } from '../../logic/store/Insights/InsightsModels';
import { useAppSelector } from '../../logic/store/Store';
import { SingleRow } from './SingleRow';
import { SectionHeader } from './Components/SectionHeader';


interface ISellerMembersViewProps
{
	onSelectSeller: (Id: string) => void;
}

export const SellerMembersView = (props: ISellerMembersViewProps) =>
{
	const { onSelectSeller } = props;

	// AI Insights objects from slice
	const sellerMemberAnalyses = useAppSelector(s => s.insights.sellerMemberAnalyses);

	// Sort the sales reps by severity
	const sortedSellers = React.useMemo(() =>
	{
		if (!sellerMemberAnalyses || sellerMemberAnalyses.length === 0)
		{
			return [];
		}

		return sortByHighestSeverity(sellerMemberAnalyses, s => s.Report?.Concerns || [], s => s.SellerName);
	}, [sellerMemberAnalyses]);

	useEffect(() =>
	{
		// If there is only one seller, automatically select it
		if(sellerMemberAnalyses?.length === 1)
		{
			onSelectSeller(sellerMemberAnalyses[0].SellerUserId);
		}
	}, [sellerMemberAnalyses, onSelectSeller]);

	return (
		<div style={{ display: 'flex', flexDirection: 'column', width: '100%', height: '98%', overflow: 'hidden' }}>
			<SectionHeader>
				Sellers
			</SectionHeader>
			<div style={{ display: 'flex', overflowY: 'auto', flexDirection: 'column', alignItems: 'center', paddingBottom: 20 }}>
				{
					sortedSellers?.map((seller) =>
					{
						return (
							<SingleRow
								key={seller.item.SellerUserId}
								Id={seller.item.SellerUserId}
								onSelect={onSelectSeller}
								Name={seller.item.SellerName}
								NumberOfItems={seller.item.GrowerAnalyses?.length}
								NumberOfItemsTitle={'Growers'}
								Severity={seller.highestSeverity}
								SeverityCount={seller.count}
							/>
						);
					})
				}
			</div>
		</div>
	);
};
